export default class InteractionManager {
    constructor() {

    }

    handleEvent(evt, data) {
        console.log('interaction manager handle', evt, data)
    }
}